import React from 'react';

interface AppModalProps {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  width?: string | number;
  id?: string;
}

const AppModal: React.FC<AppModalProps> = ({
  show,
  onClose,
  children,
  title,
  width = 400,
  id = 'app-modal'
}) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show"
        id={id}
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
        style={{
          display: 'block',
          background: 'rgba(0,0,0,0.3)',
          zIndex: 1050
        }}
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: width }}>
          <div className="modal-content" style={{ padding: '20px 31px' }}>
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close text-dark"
                aria-label="Close"
                onClick={onClose}
              />
            </div>
            {title && (
              <h5 className="ms-3" style={{
                marginBottom: 56,
                fontSize: '20px',
                fontWeight: 600,
                letterSpacing: -0.2
              }}>{title}</h5>
            )}
            {children}
          </div>
        </div>
      </div>
      {/* Backdrop */}
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} onClick={onClose}></div>
    </>
  );
};

export default AppModal;